import Details from '@Components/Event/Details';
import { EventContextProvider } from '../../context/eventContext/eventContext';

export default function EventDetails () {
  return (
    <EventContextProvider>
      <Details />
    </EventContextProvider>
  );
}